(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instalacion-acordeon"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeAccordions = () => {
      const sections = document.querySelectorAll(
        '.installation-accordion[data-single-open="true"]'
      );

      sections.forEach((section) => {
        if (section.dataset.accordionInitialized === 'true') {
          return;
        }

        section.dataset.accordionInitialized = 'true';

        const items = section.querySelectorAll(
          '.installation-accordion__item'
        );

        items.forEach((item) => {
          item.addEventListener('toggle', () => {
            if (!item.open) {
              return;
            }

            items.forEach((otherItem) => {
              if (otherItem !== item) {
                otherItem.removeAttribute('open');
              }
            });
          });
        });
      });
    };

    initializeAccordions();

    document.addEventListener(
      'shopify:section:load',
      initializeAccordions
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
